"use client";

import { useTranslations } from "next-intl";
import { Button, Typography } from "@artha/ui";
import { PERSONALIZATION_FIELD_CLASS_NAME } from "../../personalization.utils";

type OtpStepProps = {
  code: string;
  email: string;
  isRequestingCode: boolean;
  isVerifying: boolean;
  onCodeChange: (code: string) => void;
  onSubmit: () => void;
  onResend: () => void;
};

export function OtpStep({
  code,
  email,
  isRequestingCode,
  isVerifying,
  onCodeChange,
  onSubmit,
  onResend,
}: OtpStepProps) {
  const t = useTranslations("profile.resumePersonalization");

  return (
    <form
      className="space-y-4"
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit();
      }}
    >
      <div>
        <Typography as="h2" variant="large" className="font-bold text-black">
          {t("otp.title")}
        </Typography>
        <p className="mt-2 text-sm text-[#667085]">
          {isRequestingCode
            ? t("otp.sending")
            : t("otp.sent", { email })}
        </p>
      </div>
      <input
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        maxLength={6}
        aria-label={t("otp.codeLabel")}
        value={code}
        disabled={isRequestingCode}
        className={`${PERSONALIZATION_FIELD_CLASS_NAME} text-center text-xl font-bold tracking-[0.35em]`}
        onChange={(event) =>
          onCodeChange(event.target.value.replace(/\D/g, "").slice(0, 6))
        }
      />
      <Button
        type="submit"
        className="h-12 w-full rounded-[10px] bg-primary font-bold text-primary-foreground"
        disabled={isRequestingCode || isVerifying}
      >
        {isRequestingCode
          ? t("actions.sendingCode")
          : isVerifying
            ? t("actions.verifying")
            : t("actions.verify")}
      </Button>
      <button
        type="button"
        className="w-full text-center text-sm font-semibold underline"
        disabled={isRequestingCode}
        onClick={onResend}
      >
        {t("actions.resendCode")}
      </button>
    </form>
  );
}
